import React from "react";
import "./scss/index.scss";
import moment from "moment";
import "moment/locale/pl";
import classNames from "classnames";
import calendarImg from "../../images/calendar-post.svg";

moment.locale("pl");

interface IProps {
  publicationDate: any;
  customClass?: string;
  // todo
}

export const DatePosted: React.FC<IProps> = ({
  publicationDate,
  customClass,
}: IProps) => {
  return (
    <div className={classNames("date-posted", customClass)}>
      {moment(publicationDate).format("D MMM")}
    </div>
  );
};
